import { ActionCreatorBase } from 'Widgets/Scripts/ModernWidgetTypes/ActionCreatorBase';

export class MonteCarloActionCreator extends ActionCreatorBase {}